import { presetPalettes } from "@ant-design/colors";

const presetColors = Object.values(presetPalettes);
const noPresetColors = presetColors.length;

// as per design, foreground color = 8, background color = 2
export const getAvatarColorsByAlpha = (name: string): string[] => {
  if (!name) {
    return ["", ""];
  }

  const firstLetter = name.toLowerCase().charCodeAt(0) - 97;
  const matchColorIndex = firstLetter % noPresetColors;
  const matchColor = presetColors[matchColorIndex];
  if (!matchColor) {
    return ["black", "white"];
  }
  return [matchColor[8], matchColor[2]];
};
